import { Button, Card } from '@/common'

export default function MissingResourcesAlert({
  title,
  description,
  callToAction,
  onClick
}: {
  title?: string
  description?: React.ReactNode
  callToAction?: string
  onClick?: () => void
}) {
  return (
    <Card className="w-full flex flex-col items-center justify-center text-center p-4">
      <p className="font-medium text-gray-600">{title}</p>
      <p className="text-gray-500">{description}</p>
      {callToAction && (
        <Button sizeType="sm" onClick={onClick}>
          {callToAction}
        </Button>
      )}
    </Card>
  )
}
